import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const AnnouncementBar = () => {
  const [time, setTime] = useState({
    hours: 23,
    minutes: 47,
    seconds: 46
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTime(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let s = prev.seconds - 1;
        let m = prev.minutes;
        let h = prev.hours;
        if (s < 0) {
          s = 59;
          m -= 1;
        }
        if (m < 0) {
          m = 59;
          h -= 1;
        }
        return {
          hours: h,
          minutes: m,
          seconds: s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="relative w-full overflow-hidden bg-gradient-to-r from-[#4C1D95] to-[#6B21A8] py-3 px-4 text-center border-b border-[#D4A017]/30" data-id="element-14">
      <motion.div className="absolute inset-0 z-0 bg-gradient-to-r from-transparent via-white/10 to-transparent" animate={{
      x: ['-200%', '200%']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-15" />
      <div className="relative z-10 flex flex-wrap items-center justify-center gap-2 text-sm font-bold text-white sm:text-base" data-id="element-16">
        <span data-id="element-17">🔥 PRECIO DE LANZAMIENTO · Termina en</span>
        <div className="flex items-center gap-1" data-id="element-18">
          <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs text-white sm:text-sm" data-id="element-19">
            {pad(time.hours)}h
          </span>
          <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs text-white sm:text-sm" data-id="element-20">
            {pad(time.minutes)}m
          </span>
          <span className="rounded-full bg-white/20 px-2 py-0.5 text-xs text-white sm:text-sm" data-id="element-21">
            {pad(time.seconds)}s
          </span>
        </div>
        <span data-id="element-22">· Después sube $8.000</span>
      </div>
    </div>;
};